const CHANNEL = process.env.NEXT_PUBLIC_CHANNEL_NAME;

export const mapNextToContentfulLocale = (locale?: string) => {
  // For corporate channel, keep all locales including English
  if (CHANNEL === 'corporate') {
    switch (locale) {
      case 'fr':
        return 'fr-BE';
      case 'en':
        return 'en';
      default:
        return 'nl-BE';
    }
  }

  // For other channels (jobs-b2b, jobs-b2c), exclude English
  if (locale === 'fr') {
    return 'fr-BE';
  } else {
    return 'nl-BE';
  }
};

export const mapContentfulToNextLocale = (locale: string) => {
  // For corporate channel, keep all locales including English
  if (CHANNEL === 'corporate') {
    switch (locale) {
      case 'fr-BE':
        return 'fr';
      case 'en':
        return 'en';
      default:
        return 'nl';
    }
  }

  // For other channels (jobs-b2b, jobs-b2c), exclude English
  if (locale === 'fr-BE') {
    return 'fr';
  } else {
    return 'nl';
  }
};
